import { FirebaseOptions } from "firebase/app"

export default {
    apiKey: "AIzaSyBwW9SrYYRa41MD2urXebh4tQGM_tDwkQQ",
    authDomain: "cmht-643a4.firebaseapp.com",
    projectId: "cmht-643a4",
    storageBucket: "cmht-643a4.appspot.com",
    messagingSenderId: "474916191240",
    appId: "1:474916191240:web:web:bcfbdb0676a192e99e25bd",
    measurementId: "G-0C29CQZPL7",
} as FirebaseOptions
